<template>
    <resource-form :model="form.model"
        :schema="form.schema"
        :triggers="form.triggers"
        :no-form-group="true"
        @submit="onFormSubmit">
        <button type="button" slot="cancel" class="btn btn-default btn-sm" @click="onCancelButtonClick">
            Annuler
        </button>
    </resource-form>
</template>

<script>
    import ResourceForm from "components/Forms/ResourceForm"

    export default {
        data() {
            return {
                form: {
                    model: {
                        "first_name": this.user.first_name,
                        "last_name": this.user.last_name
                    },
                    schema: {
                        fields: [
                            {
                                "type": "text",
                                "label": "Prénom",
                                "model": "first_name",
                                "readonly": false,
                                "placeholder": "",
                                "disabled": false,
                                "hidden": false,
                                "help": "",
                                "hint": "",
                                "required": false
                            },
                            {
                                "type": "text",
                                "label": "Nom",
                                "model": "last_name",
                                "readonly": false,
                                "placeholder": "",
                                "disabled": false,
                                "hidden": false,
                                "help": "",
                                "hint": "",
                                "required": false
                            }
                        ],
                        optional_fields: []
                    },
                    triggers: {}
                }
            }
        },

        props: {
            user: {
                required: true
            }
        },

        components: {
            ResourceForm
        },

        methods: {
            updateUserName(payload) {
                return this.$root.axios.put(`users/${this.user.id}/update_name`, payload)
            },

            onFormSubmit({ data: model }) {
                this.updateUserName(model)
                    .then(() => {
                        this.$emit('name-updated')
                
                        // For modal handling
                        this.$parent.$emit('modal-closed')
                    })
            },

            onCancelButtonClick() {
                this.$emit('operation-canceled')
                
                // For modal handling
                this.$parent.$emit('modal-closed')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// client/components/Users/UserNameUpdateForm.vue